/**
 * created by xcc on 2022/3/15
 * 部门或管理员选择弹框
 */

import React, {Component} from 'react';
import {Button, Input, Modal, Table, Pagination, Checkbox} from "antd";
import ScrollBars from "react-custom-scrollbars";
import {getDeptUserData} from "../actions/mediaAdminister";
import $ from "jquery";
import {uuid} from "../../../utils";

const {Search} = Input;

export default class SelectModal extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            page: 1,
            size: 10,
            total: 0,
            keywords: "",
            deptUserList: [],
            useDeptUserList: [],  //选中暂存的数据
            newData: [], //确定暂存的数据
            currentEditItem: {},
            hideOnSinglePage: true,
            checkedAll: false,
            indeterminate: false
        }
    }

    componentWillMount() {

    }

    componentDidMount() {
        this.props.onRef(this);
    }

    getDeptUser(currentEdit, userData) {
        if(userData){
            this.state.useDeptUserList = userData;
        }
        let deptId = currentEdit.deptId;
        let params = {
            start: this.state.page,
            size: this.state.size,
            deptIds: deptId ? [deptId] : window.top.currentUser.deptIds
        };
        if (this.state.keywords) {
            params.accountOrName = this.state.keywords;
        }
        getDeptUserData(params, (res) => {
            let data = res.data;
            let deptUserList = [];
            let total = 0;
            if (data.length > 0) {
                deptUserList = data;
                total = res.count;
                deptUserList.forEach(item => {
                    item.checked = false;
                    //数据暂存
                    this.state.useDeptUserList.forEach((i, index) => {
                        if (item.id === i.id) {
                            item.checked = true;
                            // 是因为解决编辑值提供的id,借用已有数据显示NAME
                            this.state.useDeptUserList[index] = item;
                        }
                    })
                })
                let userIds = [];
                this.state.useDeptUserList && this.state.useDeptUserList.length > 0 && this.state.useDeptUserList.forEach(item => {
                    userIds.push(item.id);
                })
                this.state.checkedAll = !!deptUserList.every(val => userIds.includes(val.id));
                // this.state.indeterminate = !(deptUserList.every(item => item.checked === false) || deptUserList.every(item => item.checked));
            }
            this.state.hideOnSinglePage = total <= 10;
            this.setState({
                deptUserList,
                total,
                currentEditItem: currentEdit
            }, () => {
                $('.ant-pagination-options-quick-jumper').find("input").val("");
            });
        });
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            visible: nextProps.visible
        })
    }

    paginationOnChange(page, pageSize) {
        this.scrollBars && this.scrollBars.scrollTop();
        this.state.page = page;
        this.state.size = pageSize;
        this.getDeptUser(this.state.currentEditItem);
    }

    checkedAllChange(checked) {
        if (checked) {
            this.state.deptUserList.forEach(item => {
                item.checked = checked;
                let num = 0;
                if (this.state.useDeptUserList.length > 0) {
                    this.state.useDeptUserList.forEach((Item) => {
                        if (item.id !== Item.id) {
                            num++
                        }
                    })
                    if (num === this.state.useDeptUserList.length) {
                        this.state.useDeptUserList.push(item)
                    }
                } else {
                    this.state.useDeptUserList.push(item)
                }
            });
        } else {
            this.state.deptUserList.forEach(item => {
                item.checked = checked;
                this.state.useDeptUserList.forEach((Item, index) => {
                    if (item.id === Item.id) {
                        this.state.useDeptUserList.splice(index, 1)
                    }
                })
            })
        }
        this.setState({})
    }

    /**
     * 渲染
     */
    render() {
        const columns = [
            {
                title: (() => {
                    let checkedAll = this.state.deptUserList.length ? this.state.deptUserList.every(item => item.checked) : false;
                    let checkedLength = this.state.deptUserList.length ? this.state.deptUserList.filter(item => item.checked).length : 0
                    let indeterminate = this.state.deptUserList.length && checkedLength > 0 && checkedLength < this.state.deptUserList.length;
                    return (
                        <Checkbox checked={checkedAll} indeterminate={indeterminate} onChange={(e) => {
                            this.checkedAllChange(e.target.checked);
                        }}/>
                    )
                })(),
                key: 'select',
                align: 'center',
                width: 50,
                render: (text, record) => {
                    return (
                        <div><Checkbox checked={record.checked} onChange={(e) => {
                            if (!record.checked) {
                                let aNum = 0;
                                if (this.state.useDeptUserList.length > 0) {
                                    this.state.useDeptUserList.forEach((Item) => {
                                        if (record.id !== Item.id) {
                                            aNum++
                                        }
                                    })
                                    if (aNum === this.state.useDeptUserList.length) {
                                        this.state.useDeptUserList.push(record)
                                    }
                                } else {
                                    this.state.useDeptUserList.push(record)
                                }
                            } else {
                                this.state.useDeptUserList.forEach((item, index) => {
                                    if (item.id === record.id) {
                                        this.state.useDeptUserList.splice(index, 1)
                                    }
                                })
                            }
                            record.checked = !record.checked;
                            let numMax = this.state.deptUserList.length;
                            let num = 0;
                            this.state.deptUserList.forEach((item) => {
                                if (item.checked === false) {
                                    this.state.checkedAll = false;
                                } else {
                                    num++;
                                }
                            });
                            if (numMax === num) {
                                this.state.checkedAll = true;
                            }
                            this.setState({});
                        }}/></div>
                    )
                }
            },
            {
                title: '姓名',
                dataIndex: 'name',
                key: 'name',
                ellipsis: true,
            },
            {
                title: '账号',
                dataIndex: 'account',
                key: 'account',
                ellipsis: true,
            },
            {
                title: '部门',
                key: 'deptName',
                ellipsis: true,
                render: (record) => {
                    let deptNames = [];
                    record.deptList.length && record.deptList.forEach(item => {
                        deptNames.push(item.name);
                    })
                    return (
                        <div style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap"
                        }}>{deptNames.join("，")}</div>
                    )
                }
            },
        ];
        let pagination = {
            onChange: (page, pageSize) => this.paginationOnChange(page, pageSize),
            onShowSizeChange: (page, pageSize) => {
                this.state.hideOnSinglePage = false;
                this.paginationOnChange(page, pageSize)
            },
            defaultCurrent: 1,
            defaultPageSize: 10,
            current: this.state.page,
            pageSize: this.state.size,
            total: this.state.total,
            showQuickJumper: true, //快速跳转至某一页
            showSizeChanger: true,	//是否可以改变 pageSize
            hideOnSinglePage: this.state.hideOnSinglePage
        };
        return (
            <div>
                <style>{`
                    .selectManagerModal .ant-modal-body{padding: 10px 24px 10px 24px}
                `}</style>
                <Modal
                    title={this.props.modalTitle}
                    visible={this.state.visible}
                    width={800}
                    height={335}
                    onCancel={() => {
                        this.props.onCancel()
                    }}
                    className={"selectManagerModal"}
                    maskClosable={false}
                    footer={
                        <div style={{textAlign: "center"}}>
                            <Button onClick={() => {
                                this.props.onCancel()
                            }}>取消</Button>
                            <Button type={"primary"} onClick={() => {
                                this.onManagerOk()
                            }}>确定</Button>
                        </div>
                    }
                >
                    <div style={{width: "100%"}}>
                        <Search placeholder={"请输入关键词"} style={{width: 250, marginBottom: 10}}
                                value={this.state.keywords}
                                onChange={(e) => {
                                    this.setState({keywords: e.target.value});
                                }}
                                onSearch={() => {
                                    this.getDeptUser(this.state.currentEditItem);
                                }}
                        />
                        <div id={"batchSelectManagerTab"}>
                            <ScrollBars ref={(ref) => this.scrollBars = ref} autoHeight autoHeightMax={500} autoHide>
                                <Table columns={columns}
                                       dataSource={this.state.deptUserList}
                                       pagination={false}/>
                            </ScrollBars>
                            <div style={{float: "right", marginTop: "10px"}}>
                                <Pagination {...pagination}/>
                            </div>
                            <div style={{clear: "both"}} />
                        </div>
                        <style>{`#batchSelectManagerTab .ant-table-row:nth-child(2n) {background-color: rgba(245, 248, 252, 1);}
                                    #batchSelectManagerTab .ant-table-placeholder{border-bottom: 0;}
                                    `}</style>
                    </div>
                </Modal>
            </div>
        )
    }

    onManagerOk() {
        let newData = JSON.parse(JSON.stringify(this.state.useDeptUserList));
        this.props.onOk(newData);
    }
}